import { registerPlugin } from '@wordpress/plugins';
import { PluginDocumentSettingPanel } from '@wordpress/edit-post';

const selections = window.WpApidaeTemplateData.settings

const PluginPostStatusInfoTest = () => (
	<PluginDocumentSettingPanel
	className="apidae-template-editor-panel"
	title="Informations Template"
>
	<p><b>Type de post :</b> {selections.post_type_name}</p>
	<p><b>Type de template :</b> {selections.type}</p>
	<p><b>Conditions :</b> {selections.conditions_list}</p>
</PluginDocumentSettingPanel>
);
 
registerPlugin( 'post-status-info-test', { render: PluginPostStatusInfoTest } );